import { createSlice } from '@reduxjs/toolkit';

import { PriceListWithRecords, Product } from '@models';

interface ProductsState {
  products: Product[];
  statePriceList: PriceListWithRecords[];
}

export const allProducts = createSlice({
  name: 'products',

  initialState: {
    value: {
      products: [],
      statePriceList: [],
    } as ProductsState,
  },

  reducers: {
    setAllProducts: (state, action: { type: string; payload: Product[] }) => {
      state.value.products = action.payload;
    },
    setStateBasedPriceList: (state, action) => {
      state.value.statePriceList = action.payload;
    },
    setProductsInitialState: (state) => {
      state.value = { products: [], statePriceList: [] };
    },
  },
});

export const { setAllProducts, setStateBasedPriceList, setProductsInitialState } = allProducts.actions;

export default allProducts.reducer;
